import React from 'react'
import { ThemeProvider } from '@mui/material/styles'
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom'

import AppStateProvider from './context/AppState/AppStateProvider'
import { AuthStateProvider } from './context/auth'
import UserContextProvider from './context/user'
import GoogleAnalyticsWrapper from 'layouts/GoogleAnalyticsWrapper'
// import { SignIn } from 'pages/Auth/SignIn'
import { SignUp } from 'pages/Auth/SignUp'
import { SignOut } from 'pages/Auth/SignOut'
import LandingPage from 'pages/LandingPage'
import routes from './routes'
import theme from './themes/theme'

import { ForgotPassword } from 'pages/Auth/ForgotPassword'
import MyAccount from 'pages/MyAccount'
import MyBusiness from 'pages/MyBusiness'
import ClaimBusiness from 'pages/ClaimBusiness'
import { WelcomePage } from 'pages/Welcome'
import VaultPage from 'pages/Vault'
import BeneficialForm from 'pages/BeneficialInfoForm'
import FindPage from './pages/Find'
import BusinessDetails from './pages/BusinessDetails'
import ClaimBusinessDialog from './pages/ClaimBusiness'
import SocialPage from 'pages/SocialPage'
import BusinessResourceCenterCard from 'components/LandingPage/BusinessResourceCenterCard'
import IdleTimer from 'components/Common/IdleTimer'

import '@progress/kendo-theme-default/dist/all.css'
import './App.css'
import VaultVerification from 'components/Vault/VaultVerification'
import AuthLayout from 'pages/AuthLayout'
import EmailVerify from 'pages/AuthLayout/emailVerify'
import PasswordVerify from 'pages/AuthLayout/passwordVerify'
import ResendEmail from 'pages/AuthLayout/resendEmail'
import Register from 'pages/AuthLayout/signUp'
import CreatePassword from 'pages/AuthLayout/createPassword'
import OTPVerify from 'pages/AuthLayout/otpVerify'
// import MobileScreen from 'pages/MobileCheck/MobileCheck'
import { StyledEngineProvider } from '@mui/material'
import Walkthrough from 'pages/Walkthrough'
import CorrectData from 'pages/CorrectData'
import { I18nextProvider } from 'react-i18next'
import i18n from './i18n'
import ApproveShare, { DeclineShare } from 'components/Vault/VaultBOD/ApproveDeclineShare'

import EmailVerifiedMob from 'pages/AuthLayout/EmailVerifiedMob'
import NameVerifyMob from 'pages/AuthLayout/NameVerifyMob'
import PasswordVerifyMob from 'pages/AuthLayout/PasswordVerifyMob'
import AccountVerificationMob from 'components/Auth/AccountVerificationMob'

function App() {
  // // const resize = () => {
  // //   if (window.innerWidth <= 480 && window.location.pathname !== '/use-browser') {
  // //     window.location = `${window.location.origin}/use-browser`
  // //   }
  // // }

  // useEffect(() => {
  //   window.addEventListener('load', resize)
  //   window.addEventListener('resize', resize)
  // }, [])

  const IdleTimerWrapper = (COMPONENT, isVault = false) => {
    return (
      <>
        <IdleTimer
          maxIdleTime={
            isVault ? process.env['REACT_APP_MAX_IDLE_TIME_VAULT'] : process.env['REACT_APP_MAX_IDLE_TIME_DASHBOARD']
          }
        />
        {COMPONENT}
      </>
    )
  }

  if (process.env['REACT_APP_SITE_PLACEHOLDER'] === '1') {
    return (
      <div className="col-md-12 d-flex justify-content-center">
        <img
          className="img-fluid"
          src={process.env['REACT_APP_BRC_IMAGE_URL'] + '/site-placeholder/placeholder.png'}
          usemap="#image-map"
          alt="placeholder"
        />

        <map name="image-map">
          <area target="" alt="" title="" href="https://markaaz.com/dashboard/" coords="1079,1079,0,984" shape="rect" />
        </map>
      </div>
    )
  } else {
    return (
      <I18nextProvider i18n={i18n}>
        <Router>
          <GoogleAnalyticsWrapper>
            <StyledEngineProvider injectFirst>
              <ThemeProvider theme={theme}>
                <AppStateProvider>
                  <AuthStateProvider>
                    <UserContextProvider>
                      <Routes>
                        <Route path={routes.walkthrough} element={IdleTimerWrapper(<Walkthrough />)} />
                        <Route path={routes.claimBusiness} element={IdleTimerWrapper(<ClaimBusiness />)} />
                        <Route path={routes.auth.signUp} element={<SignUp />} />
                        <Route path={routes.auth.signIn} element={<AuthLayout />}>
                          <Route index element={<EmailVerify />} />
                        </Route>
                        <Route path={routes.auth.signOut} element={<SignOut />} />
                        <Route path={routes.auth.forgotPassword} element={<ForgotPassword />} />
                        <Route path={routes.home} exact element={IdleTimerWrapper(<LandingPage />)} />
                        <Route path={routes.myAccount} exact element={IdleTimerWrapper(<MyAccount />)} />
                        <Route path={routes.myBusiness} exact element={IdleTimerWrapper(<MyBusiness />)} />
                        <Route
                          path={routes.vaultVerification}
                          exact
                          element={IdleTimerWrapper(<VaultVerification />, true)}
                        />
                        <Route path={routes.welcome} exact element={IdleTimerWrapper(<WelcomePage />)} />
                        <Route path={routes.vault} exact element={IdleTimerWrapper(<VaultPage />, true)} />
                        <Route path={routes.social} exact element={IdleTimerWrapper(<SocialPage />)} />
                        <Route path="/auth" element={<AuthLayout />}>
                          <Route index element={<EmailVerify />} />
                          <Route path="/auth/EP/:EPSGId" element={<EmailVerify />} />
                          <Route path="/auth/verify-password" element={<PasswordVerify />} />
                          <Route path="/auth/resend-mail" element={<ResendEmail />} />
                          <Route path="/auth/register" element={<Register />} />
                          <Route path="/auth/create-password" element={<CreatePassword />} />
                          <Route path="/auth/verify-otp" element={<OTPVerify />} />
                          <Route exact path="/auth/mobile/sign-up" element={<NameVerifyMob />} />
                          <Route exact path="/auth/mobile/verified" element={<EmailVerifiedMob />} />
                          <Route path="/auth/mobile/password" element={<PasswordVerifyMob />} />
                          <Route path="/auth/mobile/verify-otp" element={<AccountVerificationMob />} />
                        </Route>
                        <Route path={routes.correctYourData} element={IdleTimerWrapper(<CorrectData />)} />
                        {/* <Route path="/use-browser" exact element={<MobileScreen />} /> */}
                        <Route
                          path={routes.ownerBeneficialForm}
                          exact
                          element={<BeneficialForm individialForm={false} />}
                        />
                        <Route path="/articlesharing/:shareapproveid/approved" element={<ApproveShare />} />
                        <Route path="/articlesharing/:sharedeclineid/declined" element={<DeclineShare />} />
                        <Route path={routes.find} element={IdleTimerWrapper(<FindPage />)} />
                        <Route path={routes.details} element={IdleTimerWrapper(<BusinessDetails />)} />
                        <Route path={routes.claim} element={IdleTimerWrapper(<ClaimBusinessDialog />)} />
                        <Route
                          path={routes.resources}
                          exact
                          element={IdleTimerWrapper(<BusinessResourceCenterCard />)}
                        />
                      </Routes>
                    </UserContextProvider>
                  </AuthStateProvider>
                </AppStateProvider>
              </ThemeProvider>
            </StyledEngineProvider>
          </GoogleAnalyticsWrapper>
        </Router>
      </I18nextProvider>
    )
  }
}

export default App
